export default __webpack_public_path__ + "static/media/close-dark.16667eb8.svg";